import { getCefSharp } from 'src/utils/cefSharp/getCefSharp';

export const getCefSharpBoundAsync = async () =>
  await getCefSharp('cefSharpBoundAsync');
